import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserContextService } from '../services/user-context.service';

/**
 * Blocks service desk (clerk) users from administration-only routes
 * (Services, Vendors, Invoices, Business).
 */
export const notClerkGuard: CanActivateFn = async () => {
  const userContext = inject(UserContextService);
  const router = inject(Router);

  if (!userContext.loaded()) {
    await userContext.initialize();
  }
  if (userContext.role() === 'clerk') {
    return router.createUrlTree(['/app/dashboard']);
  }
  return true;
};
